// import axios from 'axios';
import { KMSClient, EncryptCommand, DecryptCommand } from "@aws-sdk/client-kms";
import { Credentials } from "@aws-sdk/types";
import buffer from "buffer";

const getKMSClientAPI = (data) => {
    let region = "us-east-1";
    let creds = null;

    if (data?.initialAppData) {
        region = data.initialAppData.awsconfigRegion;

        if (data.initialAppData.kmsData) {
            const { accessKeyId, secretAccessKey, sessionToken } = data.initialAppData.kmsData;

            creds = {
                accessKeyId,
                secretAccessKey,
                sessionToken
            };
        }
    }

    return new KMSClient({
        region,
        credentials: creds
    });
};

export const encryptValueAPI = async (inputString, props) => {
    const kms = getKMSClientAPI(props);

    const kmKeyId = props?.initialAppData?.kmsKeyId || "";

    try {
        const command = new EncryptCommand({
            KeyId: kmKeyId,
            EncryptionAlgorithm: "SYMMETRIC_DEFAULT",
            Plaintext: inputString,
        });

        const data = await kms.send(command);

        const encResult = buffer.Buffer.from(data.CiphertextBlob).toString("base64");

        return encResult;
    } catch (err) {
        throw err;
    }
};

export const decryptValueAPI = async (inputString, props) => {
    const kms = getKMSClientAPI(props);

    const kmsKey = props?.initialAppData?.kmsKeyId || "";

    try {
        const command = new DecryptCommand({
            KeyId: kmsKey,
            EncryptionAlgorithm: "SYMMETRIC_DEFAULT",
            CiphertextBlob: buffer.Buffer.from(inputString, "base64"),
        });

        const data = await kms.send(command);

        const decResult = buffer.Buffer.from(data.Plaintext).toString();

        return decResult;
    } catch (err) {
        throw err;
    }
};
